<template>
  <div class="row mt-4 mb-4">
    <div class="col-md-4 mt-4" style="text-align: center;">
      <label :for="`form_time_begin_${date}`">Início</label>
      <input type="text"
             :id="`form_time_begin_${date}`"
             v-mask="'##:##'" placeholder="Ex. 08:00"
             v-model="form.time_begin"
             class="form-control form-control-solid" required
             @blur="onBlurTimeBegin" />
    </div>
    <div class="col-md-4 mt-4" style="text-align: center;">
      <label :for="`form_time_end_${date}`">Término</label>
      <input type="text"
             :id="`form_time_end_${date}`"
             v-mask="'##:##'" placeholder="Ex. 12:00"
             v-model="form.time_end"
             class="form-control form-control-solid" required
             @blur="onBlurTimeEnd" />
    </div>
    <div class="col-md-4 mt-4" style="text-align: center;">
      <label :for="`form_interval_minutes_${date}`">Intervalo</label>
      <h3 class="mt-3">{{ form.interval_minutes }} Min</h3>
    </div>
  </div>
  <div class="col-lg-12 mt-2" style="text-align: right;">
    <button type="button" class="btn btn-light me-2" @click="$emit('cancel')">
      Cancelar
    </button>
    <button :disabled="hideOKButton" type="button" class="btn btn-primary" @click="$emit('ok')">
      OK
    </button>
  </div>
</template>

<script>

import {mask} from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  emits: ['cancel', 'ok', 'blur-time-begin', 'blur-time-end'],
  props: {
    form: Object,
    date: [String, Number],
    hideOKButton: Boolean,
  },
  methods: {
    onBlurTimeBegin() {
      this.$emit('blur-time-begin', this.form.time_begin, `form_time_begin_${this.date}`);
    },
    onBlurTimeEnd() {
      this.$emit('blur-time-end', this.form.time_end, `form_time_end_${this.date}`);
    }
  }
}
</script>